import { clientAxios } from '@/plugins/axios'

const baseUrl = '/v1/inquiry'
const createInquiryLineLink = `${baseUrl}/line/create`
const updateCustomerInquiryStatusLink = `${baseUrl}/customer/update/status`

export const createInquiryLine = (body) => clientAxios.post(createInquiryLineLink, body)

export const updateCustomerInquiryStatus = (body) => clientAxios.put(updateCustomerInquiryStatusLink, body)
